export const yesNoOptions = [
    { label: "", value: "" },
    { label: "Yes", value: true },
    { label: "No", value: false },
]
